import { z } from 'zod'

export const securityFieldSchemas = {
  password: z.string().min(1, 'La contraseña es obligatoria'),
}
